import Checkbox from '@creditflowresearch/uilib/Checkbox';
import IconLock from '@creditflowresearch/uilib/Icon/IconLock';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import {
  RESTRICTED_ACCESS_MESSAGE,
} from '@/creditflowresearch/application/BondScreener/Sidebar/bondScreenerViewsConstants';
import useMarketsSection from './useMarketsSection';
import useIncludeNonCountablesFilter from './useIncludeNonCountablesFilter';

import styles from './markets.module.scss';

const Markets = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll } = useMarketsSection();
  const {
    checked: isNonCountableIncluded,
    disabled: isNonCountableIncludeDisabled,
    onChange: onToggleNonCountableInclude,
  } = useIncludeNonCountablesFilter();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Markets }
      header={ (
        <FilterSectionHeader
          title="MARKETS"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="marketsFiltersAllCheckbox"
            />
          ) }
          rightSlot={ (
            <Checkbox
              label="Include Non-Countables (US IG only)"
              checked={ isNonCountableIncluded }
              disabled={ isNonCountableIncludeDisabled }
              onChange={ onToggleNonCountableInclude }
              dataTest="marketsIncludeNonCountableCheckbox"
            />
          ) }
        />
      ) }
    >
      { items.map((item) => {
        const isItemDisabled = item.disabled;

        return (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ isItemDisabled ? (
                <Tooltip content={ RESTRICTED_ACCESS_MESSAGE }>
                  <IconLock className={ styles.iconLock } />{ item.name }
                </Tooltip>
              ) : item.name }
              checked={ selectedValues.includes(item.value) }
              disabled={ isItemDisabled }
              onChange={ () => toggle(item.value) }
              dataTest={ `checkbox-market-${ item.value }` }
            />
          </FilterItem>
        );
      }) }
    </FilterSection>
  );
};

export default Markets;
